
import {postBonusesCreate} from '../api/postBonusesCreate';

const setPostBonusesCreate = (params) => {
    return async (dispatch, getState) => {
        try {
            await postBonusesCreate(params);          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostBonusesCreate
}